import { useContext } from 'react';
import StoreContext from '../providers/LanguageProvider';

export const useStore = () => {
    return useContext(StoreContext);
};
